module.exports = __webpack_public_path__ + "media/customizations/spanishpeaks/logo-ac19f865e139785c4a97b7b47d124197.png";